'use client';

import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { isInventoryAuditorContext } from '@/constants/business-units';

export function RequireInventoryAuditor() {
  const { user } = useAuth();

  if (!isInventoryAuditorContext(user)) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return <Outlet />;
}
